import { Injectable } from '@angular/core';

import { IPushDeeplinkData } from '../interfaces/push.interface';

type RouteBuilder = (id: string) => string[];

const ROUTE_TABLE: Record<string, RouteBuilder> = {
	'inspection': (id: string) => ['/inspections', id, 'detail'],
	'policy-activation': (id: string) => ['/policies', id, 'activation-v2'],
};

@Injectable({
	providedIn: 'root'
})
export class PushDeeplinkResolverService {

	public resolve(data: IPushDeeplinkData | null | undefined): string[] | null {
		if (!data || !data.route || !data.id) {
			return null;
		}

		const buildRoute = ROUTE_TABLE[data.route];
		if (!buildRoute) {
			return null;
		}

		return buildRoute(data.id);
	}
}
